import React from 'react';

export function RemoveIcon() {
	return (
		<svg width="18" height="20" xmlns="http://www.w3.org/2000/svg">
			<g transform="rotate(45 10 10)">
				<rect
					id="svg_1"
					height="18"
					width="2"
					y="1"
					x="9"
					strokeWidth="0"
					stroke="#000"
					fill="#ffffff"
				/>
				<rect
					id="svg_3"
					height="2"
					width="18"
					y="9"
					x="1"
					strokeWidth="0"
					stroke="#000"
					fill="#ffffff"
				/>
			</g>
		</svg>
	);
}